import React, { useState, memo } from "react";
import IconButton from "@mui/material/IconButton";
import ImportExportIcon from '@mui/icons-material/ImportExport';
import moment from "moment-jalaali";
import Api from "../../utils/api";
import { Loading } from "../../components";
import { useSelector } from "react-redux";
import ExcelJS from "exceljs";

const TransactionExcelDownload = (props) => {
    const { object } = props;
    const AppState = useSelector(state => state);
    const [loading, setLoading] = useState(false);

    const fetchData = () => {
        setLoading(true);
        const requestObject = { ...object, excel_export: 1 };
        new Api().get('/transactions', requestObject).then(async (response) => {
            if (response) {
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Transactions');

                worksheet.columns = [
                    { header: "شناسه", key: "id", width: 20, style: headerStyle },
                    { header: "کاربر", key: "user", width: 25, style: headerStyle },
                    { header: "نوع تراکنش", key: "transaction_type", width: 20, style: headerStyle },
                    { header: "شناسه نوع", key: "transactionable_id", width: 20, style: headerStyle },
                    { header: "مبلغ", key: "amount", width: 20, style: headerStyle },
                    { header: "درگاه", key: "gateway", width: 20, style: headerStyle },
                    { header: "کد پیگیری", key: "ref_id", width: 20, style: headerStyle },
                    { header: "وضعیت", key: "status", width: 20, style: headerStyle },
                    { header: "تاریخ ایجاد", key: "created_at", width: 25, style: headerStyle },
                    { header: "تاریخ پرداخت", key: "payment_date", width: 25, style: headerStyle },
                ];

                response.forEach((entity) => {
                    worksheet.addRow({
                        id: entity.id ? `'${entity.id}'` : '-',
                        user: entity.user ? `${entity.user.name} ${entity.user.family}` : '-',
                        transaction_type: AppState.transaction.type[entity.transactionable_type] || '-',
                        transactionable_id: entity.transactionable_id || '-',
                        amount: entity.amount || '-',
                        gateway: AppState.transaction.gateway[entity.gateway] || '-',
                        ref_id: entity.ref_id || '-',
                        status: AppState.transaction.status[entity.status] || '-',
                        created_at: moment(entity.created_at).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss'),
                        payment_date: moment(entity.payment_date).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss'),
                    });
                });

                worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
                    row.eachCell((cell) => {
                        cell.font = { size: 13 };
                        cell.alignment = { vertical: 'middle', horizontal: 'center' };
                    });
                    if (rowNumber === 1) { // header
                        row.eachCell((cell) => {
                            cell.font = { size: 15, bold: true };
                            cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { argb: 'FFCCEEFF' }
                            };
                            cell.border = {
                                top: { style: 'thin' },
                                left: { style: 'thin' },
                                bottom: { style: 'thin' },
                                right: { style: 'thin' }
                            };
                        });
                    }
                });

                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `transactions_${moment().unix()}.xlsx`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);

                setLoading(false);
            } else {
                setLoading(false);
            }
        }).catch(() => {
            setLoading(false);
        });
    };

    const headerStyle = {
        font: { size: 15, bold: true },
        alignment: { horizontal: "center", vertical: "center" },
        fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFCCEEFF' }
        },
        border: {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        }
    };

    return (
        <>
            <IconButton onClick={fetchData} disabled={loading}>
                <ImportExportIcon />
            </IconButton>
            {loading && <Loading />}
        </>
    );
};

export default memo(TransactionExcelDownload);
